import { InPlayEvent } from "./InPlayEvent";
import { League } from "./League";
import { UpcommingEvent } from "./UpcommingEvent";
export const ComponentTypeMap = { InPlayEvent, UpcommingEvent, League };
export * from "./UpcommingEvent";
//# sourceMappingURL=index.js.map